import { render } from "./CopyToClipboardComponent.vue?vue&type=template&id=52c1278a"
import script from "./CopyToClipboardComponent.vue?vue&type=script&lang=js"
export * from "./CopyToClipboardComponent.vue?vue&type=script&lang=js"

import "./CopyToClipboardComponent.vue?vue&type=style&index=0&id=52c1278a&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__